(function () {
  'use strict';

  var ROOT = '[data-airo715001-section]';

  function addCleanup(root, callback) {
    root.airo715001Cleanup = root.airo715001Cleanup || [];
    root.airo715001Cleanup.push(callback);
  }

  function initReveal(root) {
    var revealItems = Array.prototype.slice.call(root.querySelectorAll('.dtc-reveal'));
    var motionSelector = [
      'img', 'h1', 'h2', 'h3', 'p', '.dtc-kicker', '.dtc-eyebrow',
      '.dtc-hero-points li', '.dtc-button', '.dtc-tab', '.dtc-chip',
      '.dtc-use', '.dtc-option-group', '.dtc-summary-card', '.dtc-stat',
      '.dtc-spec', '.dtc-faq details', '.dtc-proof-stat', '.dtc-proof-badge',
      '.dtc-vers-tab', '.dtc-vers-card', '.dtc-quality-card', '.dtc-quality-icon'
    ].join(',');
    var motionItems = Array.prototype.slice.call(root.querySelectorAll(motionSelector));
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    motionItems.forEach(function (item, index) {
      if (item.classList.contains('dtc-motion')) return;
      item.classList.add('dtc-motion');
      item.style.setProperty('--dtc-delay', ((index % 6) * 65) + 'ms');
    });

    if (reduced || !('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) { item.classList.add('dtc-visible'); });
      motionItems.forEach(function (item) { item.classList.add('dtc-motion-visible'); });
      return;
    }

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('dtc-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });

    var motionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('dtc-motion-visible');
        motionObserver.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -7% 0px' });

    revealItems.forEach(function (item) { revealObserver.observe(item); });
    motionItems.forEach(function (item) { motionObserver.observe(item); });
    addCleanup(root, function () { revealObserver.disconnect(); motionObserver.disconnect(); });
  }

  function initProgress(root) {
    var progress = root.querySelector('[data-airo715001-progress]');
    if (!progress) return;
    var frame = 0;
    function update() {
      frame = 0;
      var top = window.pageYOffset || document.documentElement.scrollTop;
      var height = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.width = (height > 0 ? (top / height) * 100 : 0) + '%';
    }
    function requestUpdate() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    update();
    addCleanup(root, function () { window.removeEventListener('scroll', requestUpdate); window.cancelAnimationFrame(frame); });
  }

  function initBuyScroll(root) {
    var productBuySection = document.querySelector('[id^="product-buy-section-"]');
    root.querySelectorAll('a[data-airo-buy-scroll], a[href^="#product-buy-section-"]').forEach(function (link) {
      if (link.dataset.airoBuyScrollReady === 'true') return;
      link.dataset.airoBuyScrollReady = 'true';
      if (productBuySection) link.setAttribute('href', '#' + productBuySection.id);
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initFeatures(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-airo-feature]'));
    var visual = root.querySelector('.dtc-feature-visual');
    var image = root.querySelector('[data-airo-feature-image]');
    var title = root.querySelector('[data-airo-feature-title]');
    var copy = root.querySelector('[data-airo-feature-copy]');
    var chips = root.querySelector('[data-airo-feature-chips]');
    if (!tabs.length || !visual || !image || !title || !copy || !chips) return;
    var switchTimer = 0;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (item) { item.setAttribute('aria-selected', 'false'); });
        tab.setAttribute('aria-selected', 'true');
        visual.classList.add('dtc-switching');
        window.clearTimeout(switchTimer);
        switchTimer = window.setTimeout(function () {
          image.src = tab.dataset.image;
          image.alt = tab.dataset.alt || '';
          title.textContent = tab.dataset.title || '';
          copy.textContent = tab.dataset.copy || '';
          chips.replaceChildren();
          [tab.dataset.chipOne, tab.dataset.chipTwo].filter(Boolean).forEach(function (value) {
            var chip = document.createElement('span');
            chip.className = 'dtc-chip';
            chip.textContent = value;
            chips.appendChild(chip);
          });
          visual.classList.remove('dtc-switching');
        }, 180);
      });
    });
    addCleanup(root, function () { window.clearTimeout(switchTimer); });
  }

  function initLifestyle(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-airo-life-slide]'));
    var frame = root.querySelector('.dtc-slide-frame');
    var image = root.querySelector('[data-airo-life-image]');
    var caption = root.querySelector('[data-airo-life-caption]');
    if (!slides.length || !frame || !image || !caption) return;
    var index = 0;
    var switchTimer = 0;
    var autoplayTimer = 0;
    var delay = Math.max(3000, Number(root.dataset.autoplayDelay) || 5000);

    function show(next) {
      index = (next + slides.length) % slides.length;
      var item = slides[index];
      frame.classList.add('dtc-switching');
      window.clearTimeout(switchTimer);
      switchTimer = window.setTimeout(function () {
        image.src = item.dataset.image;
        image.alt = item.dataset.alt || '';
        caption.textContent = item.dataset.caption || '';
        frame.classList.remove('dtc-switching');
      }, 170);
    }
    function stop() { window.clearInterval(autoplayTimer); autoplayTimer = 0; }
    function start() {
      stop();
      if (root.dataset.autoplay !== 'true' || slides.length < 2 || document.hidden) return;
      autoplayTimer = window.setInterval(function () { show(index + 1); }, delay);
    }
    root.querySelectorAll('[data-airo-life-direction]').forEach(function (button) {
      button.addEventListener('click', function () {
        show(index + (button.dataset.airoLifeDirection === 'next' ? 1 : -1));
        start();
      });
    });
    frame.addEventListener('pointerenter', stop);
    frame.addEventListener('pointerleave', start);
    frame.addEventListener('touchstart', stop, { passive: true });
    frame.addEventListener('touchend', start, { passive: true });
    start();
    addCleanup(root, function () { stop(); window.clearTimeout(switchTimer); });
  }

  function initOrder(root) {
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-group]'));
    var summary = root.querySelector('[data-airo-order-summary]');
    if (!groups.length || !summary) return;
    function update() {
      summary.textContent = groups.map(function (group) {
        var active = group.querySelector('.dtc-option[aria-pressed="true"]');
        return active ? active.dataset.value : '';
      }).filter(Boolean).join(' · ');
    }
    groups.forEach(function (group) {
      group.querySelectorAll('.dtc-option').forEach(function (option) {
        option.addEventListener('click', function () {
          group.querySelectorAll('.dtc-option').forEach(function (item) { item.setAttribute('aria-pressed', 'false'); });
          option.setAttribute('aria-pressed', 'true');
          update();
        });
      });
    });
    update();
  }

  function initCounters(root) {
    var counters = Array.prototype.slice.call(root.querySelectorAll('[data-count]'));
    if (!counters.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function animate(element) {
      if (element.dataset.airoCounted === 'true') return;
      element.dataset.airoCounted = 'true';
      var target = Number(element.dataset.count) || 0;
      var suffix = element.dataset.suffix || '';
      var start = performance.now();
      function tick(now) {
        var progress = Math.min(1, (now - start) / 900);
        var eased = 1 - Math.pow(1 - progress, 3);
        element.textContent = Math.round(target * eased).toLocaleString() + suffix;
        if (progress < 1) window.requestAnimationFrame(tick);
      }
      if (reduced) element.textContent = target.toLocaleString() + suffix;
      else window.requestAnimationFrame(tick);
    }
    if (!('IntersectionObserver' in window)) counters.forEach(animate);
    else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) { animate(entry.target); observer.unobserve(entry.target); } });
      }, { threshold: 0.35 });
      counters.forEach(function (counter) { observer.observe(counter); });
      addCleanup(root, function () { observer.disconnect(); });
    }
  }

  function initFaq(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.dtc-faq details'));
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  }

  function initVersatility(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.dtc-vers-tab'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('.dtc-vers-card'));
    var stage = root.querySelector('.dtc-vers-stage');
    if (!tabs.length || !cards.length || !stage) return;
    var current = 0;
    var timer = 0;
    var scrollTimer = 0;
    var mobile = window.matchMedia('(max-width: 749px)');
    var delay = Math.max(3000, Number(root.dataset.autoplayDelay) || 5000);

    function update(index) {
      current = (index + cards.length) % cards.length;
      tabs.forEach(function (tab, i) { tab.setAttribute('aria-selected', i === current ? 'true' : 'false'); });
      cards.forEach(function (card, i) { card.classList.toggle('dtc-active', i === current); });
    }
    function activate(index, scroll) {
      update(index);
      if (scroll && mobile.matches) stage.scrollTo({ left: cards[current].offsetLeft, behavior: 'smooth' });
    }
    function stop() { window.clearInterval(timer); timer = 0; }
    function start() {
      stop();
      if (root.dataset.autoplay !== 'true' || cards.length < 2 || document.hidden) return;
      timer = window.setInterval(function () { activate(current + 1, mobile.matches); }, delay);
    }
    tabs.forEach(function (tab, index) { tab.addEventListener('click', function () { activate(index, true); start(); }); });
    cards.forEach(function (card, index) {
      function select() { activate(index, false); start(); }
      card.addEventListener('click', select);
      card.addEventListener('keydown', function (event) { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); select(); } });
    });
    stage.addEventListener('scroll', function () {
      if (!mobile.matches) return;
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        var nearest = 0;
        var distance = Infinity;
        cards.forEach(function (card, index) {
          var delta = Math.abs(card.offsetLeft - stage.scrollLeft);
          if (delta < distance) { distance = delta; nearest = index; }
        });
        update(nearest);
      }, 90);
    }, { passive: true });
    stage.addEventListener('pointerenter', stop);
    stage.addEventListener('pointerleave', start);
    stage.addEventListener('touchstart', stop, { passive: true });
    stage.addEventListener('touchend', start, { passive: true });
    update(0);
    start();
    addCleanup(root, function () { stop(); window.clearTimeout(scrollTimer); });
  }

  function init(root) {
    if (!root || root.dataset.airo715001Ready === 'true') return;
    root.dataset.airo715001Ready = 'true';
    initReveal(root);
    initProgress(root);
    initBuyScroll(root);
    initFeatures(root);
    initLifestyle(root);
    initOrder(root);
    initCounters(root);
    initFaq(root);
    initVersatility(root);
  }

  function initAll(scope) {
    if (scope.matches && scope.matches(ROOT)) init(scope);
    scope.querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.matches && event.target.matches(ROOT) ? [event.target] : Array.prototype.slice.call(event.target.querySelectorAll(ROOT));
    roots.forEach(function (root) {
      (root.airo715001Cleanup || []).forEach(function (callback) { callback(); });
      root.airo715001Cleanup = [];
    });
  });
})();
